"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../../Styler/styler"));

var _DraggableRowSource = _interopRequireDefault(require("./DraggableRowSource"));

var _getNativeProps = _interopRequireDefault(require("../../helpers/get-native-props"));

var _reactDnd = require("react-dnd");

var _reactDom = require("react-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var rowSource = {
  beginDrag: function beginDrag(props) {
    return {
      initialIndex: props.index,
      index: props.index
    };
  },
  endDrag: function endDrag(props, monitor, component) {
    var _monitor$getItem = monitor.getItem(),
        initialIndex = _monitor$getItem.initialIndex,
        index = _monitor$getItem.index;

    if (index !== initialIndex) {
      props.onDropRow(initialIndex, index);
    }
  }
};
var rowTarget = {
  hover: function hover(props, monitor, component) {
    if (!component) return;
    var dragIndex = monitor.getItem().index;
    var hoverIndex = props.index;
    if (dragIndex === hoverIndex) return;
    var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    var hoverClientY = monitor.getClientOffset().y - hoverBoundingRect.top; // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    var notMovedUp = dragIndex > hoverIndex && hoverClientY > hoverMiddleY;
    var notMovedDown = dragIndex < hoverIndex && hoverClientY < hoverMiddleY;
    if (notMovedUp || notMovedDown) return;
    props.onMoveRow(dragIndex, hoverIndex);
    monitor.getItem().index = hoverIndex;
  }
};

var collectSource = function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
};

var collectTarget = function collectTarget(connect) {
  return {
    connectDropTarget: connect.dropTarget()
  };
};

var DraggableRow =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DraggableRow, _React$Component);

  function DraggableRow() {
    _classCallCheck(this, DraggableRow);

    return _possibleConstructorReturn(this, _getPrototypeOf(DraggableRow).apply(this, arguments));
  }

  _createClass(DraggableRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          connectDragSource = _this$props.connectDragSource,
          connectDragPreview = _this$props.connectDragPreview,
          connectDropTarget = _this$props.connectDropTarget,
          isDragging = _this$props.isDragging,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["connectDragSource", "connectDragPreview", "connectDropTarget", "isDragging", "children"]);

      var classes = ['co-table__row', {
        'co-table__drag-handle--grabbing': isDragging
      }];
      return _react.default.createElement(_styler.default, {
        classNames: classes,
        modifiers: props
      }, function (styles) {
        return connectDragPreview(connectDropTarget(_react.default.createElement("tr", _extends({
          className: styles
        }, (0, _getNativeProps.default)(props)), _react.default.createElement(_DraggableRowSource.default, {
          connectDragSource: connectDragSource
        }), children)));
      });
    }
  }]);

  return DraggableRow;
}(_react.default.Component);

var exclusiveRowColorsVariations = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('success', 'danger', 'info', 'warning');
DraggableRow.propTypes = {
  /** {---} Sequence of: @@Table.Data@@ (optional, min: 1), @@Table.ActionData@@ (optional, max: 1) OR @@Table.Header@@ (optional, min: 1), @@Table.ActionHeader@@ (optional, max: 1) */
  children: _propTypes.any.isRequired,
  disabled: _propTypes.bool,
  active: _propTypes.bool,
  success: exclusiveRowColorsVariations,
  danger: exclusiveRowColorsVariations,
  info: exclusiveRowColorsVariations,
  warning: exclusiveRowColorsVariations
};

var _default = (0, _reactDnd.DropTarget)('DraggableRow', rowTarget, collectTarget)((0, _reactDnd.DragSource)('DraggableRow', rowSource, collectSource)(DraggableRow));

exports.default = _default;
DraggableRow.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DraggableRow",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of: @@Table.Data@@ (optional, min: 1), @@Table.ActionData@@ (optional, max: 1) OR @@Table.Header@@ (optional, min: 1), @@Table.ActionHeader@@ (optional, max: 1)"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "active": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "success": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowColorsVariations"
      },
      "required": false,
      "description": ""
    },
    "danger": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowColorsVariations"
      },
      "required": false,
      "description": ""
    },
    "info": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowColorsVariations"
      },
      "required": false,
      "description": ""
    },
    "warning": {
      "type": {
        "name": "custom",
        "raw": "exclusiveRowColorsVariations"
      },
      "required": false,
      "description": ""
    }
  }
};